import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import RegistrationContext from "../../context/registration/registrationContext";
// import UserContext from "../../context/users/userContext";
import InterestContext from "../../context/interest/interestContext";

import { fetchBrands, brandDomains } from "../brand";
import { getsites } from "../findBrand";

const HomeLayout = ({ children }) => {
  const registrationContext = useContext(RegistrationContext);
  // const userContext = useContext(UserContext);
  // const { getProgramTypes } = userContext;
  const interestContext = useContext(InterestContext);
  const {getProgramtypesforweb} = interestContext;

  const [logosLoaded, setLogosLoaded] = useState(false);
  const [brandDetails, setBrandDetails] = useState({
    brandPhoto: null,
    brandName: "",
  });

  const {
    formData: { learningCenterName },
  } = registrationContext;

  const brand = getsites();

  useEffect(() => {
    const loadBrands = async () => {
      await fetchBrands();
      setLogosLoaded(true);
    };
    loadBrands();
  }, []);

  // Load program types when the landing page loads
  useEffect(() => {
    // getProgramTypes();
    getProgramtypesforweb();
  }, []);

  useEffect(() => {
    if (logosLoaded && brand) {
      if (brand === brandDomains.brand_pbia?.name) {
        // Set specific details for Palm Beach International
        setBrandDetails({
          brandIcon: brandDomains.brand_pbia?.brandIcon || null,
          brandPhoto: brandDomains.brand_pbia?.brandPhoto || null,
          brandName: brandDomains.brand_pbia?.name || "Default Brand",
        });
      } else {
        const brandInfo = brandDomains[`brand_${brand.toLowerCase()}`];
        // console.log("brandInfo", brandInfo);

        if (brandInfo) {
          setBrandDetails({
            brandIcon: brandInfo.brandIcon || null,
            brandPhoto: brandInfo.brandPhoto || null,
            brandName: brandInfo.name || "Default Brand",
          });
        }
      }
    }
  }, [logosLoaded, brand]);

  return (
    <section id="enrollement-interest-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{brandDetails.brandName}</title>
        {brandDetails.brandIcon && (
          <link rel="icon" type="image/png" href={brandDetails.brandIcon} />
        )}
      </Helmet>
      <div className="info-header" style={{display: brand === 'learn4life' || brand === 'flexhigh' ? 'none': 'block'}}>
        <div className="container">
          <div className="call">
            <p></p>
          </div>
        </div>
      </div>
      <div className="brand-header" style={{display: brand === 'learn4life' || brand === 'flexhigh' ? 'none': 'block'}}>
        <div className="text-center">
          {/* {brandDetails.brandName === "LLAC" ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "20px",
              }}
            >
              {Object.keys(brandDomains).map((key) => {
                const brandInfo = brandDomains[key];
                if (brandInfo) {
                  const { brandPhoto, name } = brandInfo;
                  return (
                    brandPhoto && (
                      <div
                        key={key}
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <img
                          src={brandPhoto}
                          alt={`${name} Photo`}
                          height="60px" 
                          width="auto"   
                        className="brand-photo"
                        />
                      </div>
                    )
                  );
                }
                return null;
              })}
            </div>
          ) : ( */}
            <p>
              {brandDetails.brandPhoto ? (
                <img
                  src={brandDetails.brandPhoto}
                  alt={`${brandDetails.brandName} Photo`}
              height="70px"
                />
              ) : (
              "" //No message to display
              )}
            </p>
          {/* )} */}
        </div>
      </div>
      {/* <div className="brand-hero">
        <div className="container">
          <p>
            We are excited that you are interested in enrolling in our school.
            You have taken a very important first step toward setting new goals
            for your future, and we are here to support you on your path to
            success. Our school is dedicated to providing you with a
            personalized learning plan that is unique to your needs. We look
            forward to meeting you and learning more about you!
          </p>
        </div>
      </div> */}
      {children}
    </section>
  );
};

export default HomeLayout;